// Purpose: Open event-scoped Promotion Studio from a saved record or public listing page.
// Features: Canonical Social Promotion entitlement and immutable source identity handoff.
// Dependencies: Cached event context, React Router, and shared event entitlement helper.
// Important behavior: Collection scope needs no record ID. The destination reads saved public fields;
// no unsaved form data is passed or published.
import React from "react";
import { Link } from "react-router-dom";
import { useEventContext } from "../../hooks/use_event_context";
import { hasPurchasedAddOn } from "../../utils/event_addons";
import { PROMOTION_SOURCES } from "../constants/promotion_source_pages";

export default function PromotionSourceButton({ source, sourceId, sourceScope = "record", ariaLabel, className = "btn btn-outline-primary" }) {
  const { eventId, eventslug, eventDoc } = useEventContext({ redirectIfNotFound: false });
  const isCollection = sourceScope === "collection";
  const definition = Object.prototype.hasOwnProperty.call(PROMOTION_SOURCES, source) ? PROMOTION_SOURCES[source] : null;
  if (!eventId || !eventslug || !definition || (!isCollection && (!sourceId || definition.collectionOnly)) || (isCollection && !definition.page) || !["record", "collection"].includes(sourceScope) || !hasPurchasedAddOn(eventDoc, "social")) return null;
  const sourceQuery = isCollection ? "sourceScope=collection" : `sourceId=${encodeURIComponent(sourceId)}`;
  return <Link className={className} aria-label={ariaLabel}
    to={`/${encodeURIComponent(eventslug)}/promotion_studio?source=${encodeURIComponent(source)}&${sourceQuery}`}>
    Publish to Socials
  </Link>;
}
